import React, { useState, useEffect } from 'react';
import { Card, Button, Form, ListGroup, Badge, Row, Col } from 'react-bootstrap';
import { Plus, X } from 'react-bootstrap-icons';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const LabelsSettings = ({ activeProfileId }) => {
    const [labels, setLabels] = useState([]);
    const [newLabelName, setNewLabelName] = useState('');
    const [newLabelColor, setNewLabelColor] = useState('#007bff');

    useEffect(() => {
        if (activeProfileId) {
            fetchLabels();
        }
    }, [activeProfileId]);

    const fetchLabels = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/life/profiles/${activeProfileId}/labels`);
            setLabels(response.data);
        } catch (error) {
            console.error('Error fetching labels:', error);
        }
    };

    const handleCreateLabel = async () => {
        if (!newLabelName.trim()) return;
        
        try {
            const response = await axios.post(`${API_BASE_URL}/api/life/profiles/${activeProfileId}/labels`, {
                name: newLabelName,
                color: newLabelColor
            });
            setLabels([...labels, response.data]);
            setNewLabelName('');
            setNewLabelColor('#007bff');
        } catch (error) {
            console.error('Error creating label:', error);
        }
    };

    const handleDeleteLabel = async (labelId) => {
        try {
            await axios.delete(`${API_BASE_URL}/api/life/labels/${labelId}`);
            setLabels(labels.filter(label => label.id !== labelId));
        } catch (error) {
            console.error('Error deleting label:', error);
        }
    };

    return (
        <Card>
            <Card.Header>
                <h5>Task Labels</h5>
            </Card.Header>
            <Card.Body>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Control
                            type="text"
                            placeholder="Label name"
                            value={newLabelName}
                            onChange={(e) => setNewLabelName(e.target.value)}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="d-flex align-items-center gap-2">
                            <Form.Control
                                type="color"
                                value={newLabelColor}
                                onChange={(e) => setNewLabelColor(e.target.value)}
                                style={{ width: '50px', height: '38px' }}
                            />
                            <span 
                                style={{ 
                                    backgroundColor: newLabelColor, 
                                    color: 'white',
                                    border: '1px solid #ccc',
                                    padding: '6px 12px',
                                    fontSize: '12px',
                                    borderRadius: '4px',
                                    display: 'inline-block'
                                }}
                            >
                                {newLabelName || 'Preview'}
                            </span>
                        </div>
                    </Col>
                    <Col md={3}>
                        <Button 
                            variant="primary" 
                            onClick={handleCreateLabel}
                            disabled={!newLabelName.trim()}
                        >
                            <Plus /> Add Label
                        </Button>
                    </Col>
                </Row>

                {labels.length === 0 ? (
                    <p className="text-muted">No labels created yet.</p>
                ) : (
                    <ListGroup variant="flush">
                        {labels.map(label => (
                            <ListGroup.Item key={label.id} className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <span 
                                        style={{ 
                                            backgroundColor: label.color, 
                                            color: 'white',
                                            border: '1px solid #ccc',
                                            padding: '6px 12px',
                                            fontSize: '12px',
                                            borderRadius: '4px',
                                            display: 'inline-block'
                                        }}
                                        className="me-2"
                                    >
                                        {label.name}
                                    </span>
                                </div>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleDeleteLabel(label.id)}
                                >
                                    <X />
                                </Button>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </Card.Body>
        </Card>
    );
};

export default LabelsSettings;
